import { useMaskito } from '@maskito/react';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { FormEventHandler, ReactNode, useState } from 'react';
import { Input, InputProps } from '@e2n/ui';
import { faEuro } from '@fortawesome/pro-regular-svg-icons';

const numberMaskingOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: '.',
  maximumFractionDigits: 2,
  decimalSeparator: ',',
  min: 0,
});

export function MoneyInput(
  props: InputProps & {
    onInput?: FormEventHandler<HTMLInputElement>;
    isIconVisible?: boolean;
    unit?: ReactNode;
  },
) {
  const inputRef = useMaskito({ options: numberMaskingOptions });
  const [focus, setFocus] = useState(false);
  const {
    onInput,
    onBlur = undefined,
    className,
    isIconVisible = true,
    ...otherProps
  } = props;

  return (
    <div className="flex items-center relative">
      <div className="grow">
        <Input
          onFocus={() => {
            setFocus(true);
          }}
          {...otherProps}
          className={`min-w-full grow ${className}`}
          endIcon={isIconVisible ? faEuro : undefined}
          ref={inputRef}
          onInput={onInput}
          onBlur={(e) => {
            setFocus(false);
            onBlur?.(e);
          }}
        />
      </div>
      {props.unit && (
        <span
          className={`${
            focus ? 'text-primary-blue-600' : 'text-neutrals-700'
          } font-extralight mr-4 absolute right-0`}>
          {props.unit}
        </span>
      )}
    </div>
  );
}
